import { render, staticRenderFns } from "./MplsVpn.vue?vue&type=template&id=e3c646c4&"
import script from "./MplsVpn.vue?vue&type=script&lang=js&"
export * from "./MplsVpn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports